import { render, staticRenderFns } from "./juhe.vue?vue&type=template&id=60a5e3ab&scoped=true"
import script from "./juhe.vue?vue&type=script&lang=js"
export * from "./juhe.vue?vue&type=script&lang=js"
import style0 from "./juhe.vue?vue&type=style&index=0&id=60a5e3ab&prod&lang=scss"
import style1 from "./juhe.vue?vue&type=style&index=1&id=60a5e3ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a5e3ab",
  null
  
)

export default component.exports